import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';

const VocalTrainingDetails = () => (
	<motion.section
		initial={{ opacity: 0, y: 50 }}
		animate={{ opacity: 1, y: 0 }}
		transition={{ duration: 0.8 }}
		style={{
			minHeight: '100vh',
			display: 'flex',
			alignItems: 'center',
			scrollSnapAlign: 'start',
		}}>
		<Container
			className='d-flex flex-column justify-content-center align-items-center text-center px-3 px-md-5 bg-waterColorBlue'
			style={{ minHeight: '100vh' }}>
			<h1
				className='display-6 fw-bold mb-1 text-center '
				style={{ color: '#384971' }}>
				Why We Teach the Way We Do
			</h1>
			<p className='text-muted fs-6 fst-italic mb-4 text-center'>
				Building skills that extend well beyond the arts
			</p>
			<Row className='justify-content-center'>
				<Col lg={10}>
					<p className='fs-6 text-start lh-base'>
						Color Your Voice specializes in personalized voice
						training for students ages 8–18. Whether your child is
						just beginning their vocal journey or preparing for
						professional auditions, our private and group lessons
						are designed to build confidence, technique, and
						authentic self-expression. Training covers a wide range
						of vocal styles—including musical theatre, pop,
						classical, and contemporary. With a focus on healthy
						vocal habits and creative exploration, our studio
						provides a supportive environment where young voices
						grow and thrive.
					</p>
					<p className='fs-6 text-start lh-base'>
						Coaching goes beyond technique. We emphasize
						storytelling and character development, drawing on
						professional training from institutions like UCLA
						(Grace), AMDA (Anthony), and SMU (Annelise). Great
						singing is rooted in truthful, connected performance. As
						seasoned theatre professionals, we help students of all
						levels bring songs to life, making audition coaching and
						performance preparation uniquely comprehensive.
					</p>
					<p className='fs-6 text-start lh-base'>
						Many students go on to pursue musical theatre and acting
						at the collegiate level. Alumni have been accepted into
						prestigious BFA programs including NYU, USC, Emerson,
						Syracuse, Elon, the University of Minnesota, and Viterbo
						University. It’s our joy to prepare students not just to
						sing—but to truly perform—giving them the tools to
						succeed in auditions, callbacks, and wherever their
						voice takes them. These are skills that extend well
						beyond the arts — supporting growth in school,
						leadership, public speaking, and every area where
						confident, empathetic communication matters.
					</p>
				</Col>
			</Row>
		</Container>
	</motion.section>
);

export default VocalTrainingDetails;
